import * as React from 'react';
import { Button, ButtonProps } from 'react-bootstrap';

export type ActionButtonProps = React.PropsWithChildren<Omit<ButtonProps & React.HTMLAttributes<HTMLButtonElement>, 'onClick'> & {
    stopPropagation?: boolean;

    onClick?: React.MouseEventHandler<HTMLButtonElement>;

}>;

export function ActionButton(props: ActionButtonProps & {
    onClickAction?: () => void;
}): JSX.Element;
export function ActionButton<TClickArgs>(props: ActionButtonProps & {
    clickArgs: TClickArgs;
    onClickAction: (clickArgs: TClickArgs) => void;
}): JSX.Element;
export function ActionButton<TClickArgs>({ onClick, onClickAction, clickArgs, stopPropagation, ...rest }: ActionButtonProps & {
    clickArgs?: TClickArgs;
    onClickAction?: (clickArgs?: TClickArgs) => void;
}) {
    const handleClick = React.useCallback((e: React.MouseEvent<HTMLButtonElement & typeof Button>) => {

        e.preventDefault();

        if (stopPropagation) {
            e.stopPropagation();
        }
        e.currentTarget.blur();

        if (onClickAction) {
            onClickAction(clickArgs);
        }
        if (onClick) {
            onClick(e);
        }
    }, [stopPropagation, onClick, onClickAction, clickArgs]);

    return (
        <Button {...rest} onClick={handleClick} />
    );
}
